module.exports = __webpack_public_path__ + "static/fonts/Fact-Bold.27bfa54.woff";